export default "__VITE_ASSET__BNe$REBl__"